import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solucoes',
  templateUrl: './solucoes.component.html',
  styleUrls: ['./solucoes.component.scss']
})
export class SolucoesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
